// components/LabDetails.js
import React from "react";
import { FaMapMarkerAlt, FaCalendarAlt, FaUserFriends } from "react-icons/fa";
import classes from "./SelectedLabDetails.module.css";

const SelectedLabDetails = ({ lab, onClose, STATUS_COLORS }) => {
  console.log(lab.sadcas);
  return (
    <div className={classes.labDetailsCard}>
      <div className="d-flex align-items-center justify-content-between mb-3">
        <h5 className="m-0">{lab.labName}</h5>
        <button onClick={onClose}>✕</button>
      </div>
      <div className={classes.meta}>
        <p><FaMapMarkerAlt /> {lab.city}, {lab.province}</p>
        <p><FaCalendarAlt /> Last inspected: {lab.lastInspected}</p>
      </div>
      <div className={classes.tags}>
        <span className={`${classes.status}`} style={{ color: STATUS_COLORS[lab.status] || "#000" }}>{lab.status} Status</span>
      </div>

      {/* <div className={`d-flex align-items-center justify-content-between ${classes.tabs}`}>
        <button className={classes.active}>Overview</button>
        <button>Performance</button>
        <button>Details</button>
      </div> */}

      <hr />

      <div className={classes.profileCard}>
        <h4>Laboratory Profile</h4>
        <div className="grid">
          <p><span>Director:</span> {lab.personnelName}</p>
          <p><FaUserFriends /> {lab.totalStaff} members</p>
          {/* <p><span>Accreditations:</span> <span className={classes.badge}>ISO 15189</span></p> */}
        </div>
      </div>

      <div className={classes.stats}>
        <div className={`${classes.stat} ${classes.green}`}>
          <h3>{lab.performance}%</h3>
          <p>Overall Performance</p>
        </div>
        <div className={`${classes.stat} ${lab.sadcas ? classes.blue : classes.red}`}>
          <h3>{lab.sadcas ? "Yes" : "No"}</h3>
          <p>Accredited</p>
        </div>
      </div>
    </div>
  );
};

export default SelectedLabDetails;